<template>
  <Modal v-model="showCertSelectModal"
    scrollable
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    @cert-verified="certSigned"
    title="CA签名">
    <CertSignature
      :mode="signMode"
      :dataToSign="dataSigning"
      @cert-verified="certSigned"
      v-if="showCertSelectModal" />
    <div slot="footer">
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import CertSignature from './CertSignature'
export default {
  name: 'cert-select-modal',
  props: {
    mode: String,
    callback: Function,
    show: Boolean,
    dataSigning: String
  },
  components: {
    CertSignature
  },
  data () {
    return {
      showCertSelectModal: false
    }
  },
  computed: {
    signMode () {
      if (this.mode) {
        return this.mode
      } else {
        return null
      }
    }
  },
  watch: {
    show: function (newVal) {
      this.showCertSelectModal = newVal
    }
  },
  methods: {
    closeModal () {
      this.showCertSelectModal = false
      this.$emit('close-modal')
    },
    certSigned (cert) {
      this.$emit('cert-verified', cert, this.callback)
      this.closeModal()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
